var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpThinOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.973,
    height: 13.852,
    viewBox: "0 0 35.973 13.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#f95108;stroke-linecap:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.719 11.132) rotate(-90)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 8.413,
    y2: 15.156
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 15.156,
    x2: 8.413,
    transform: "translate(0 15.378)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpThinOrange);
export default __webpack_public_path__ + "static/media/chevron-up-thin-orange.daa6ad3afbbd52b1579e3b7fb539220a.svg";
export { ForwardRef as ReactComponent };